<ng-template let-extraClass="extraClass" #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="pageTitle"
      [canGoBack]="!windowService.isDesktopRes"
      [showLinkIcon]="loaded"
      [linkIcon]="topNavIcon"
      (linkAction)="topNavAction()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">

    @if (loaded) {

      <!-- ===== ENVELOPE ===== -->
      @if (kind === 'envelope' && envelope) {
        <tidy-card>
          <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
            <tidy-text [header]="cardTitle" [translate]="false" />
            <span class="es-status" [ngClass]="statusClass">{{ statusText | translate }}</span>
          </tidy-row>

          @if (hasRecipient) {
            <tidy-divider />
            <tidy-row class="vertical-align-center extra-top-padding">
              <tidy-initials-icon [fullName]="envelope.recipient_name" />
              <tidy-text [body]="envelope.recipient_name" [translate]="false" />
              <span class="es-sep">·</span>
              <tidy-text [helper]="envelope.recipient_email" [translate]="false" />
            </tidy-row>
          }
        </tidy-card>

        <tidy-row><tidy-text [title]="'Details'" /></tidy-row>
        <tidy-card>
          @for (row of detailRows; track row.label) {
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [helper]="row.label" />
              <tidy-text [body]="row.value" [translate]="false" />
            </tidy-row>
          }
        </tidy-card>

        @if (timeline.length) {
          <tidy-row><tidy-text [title]="'Activity'" /></tidy-row>
          <tidy-card>
            @for (event of timeline; track $index) {
              <tidy-row class="vertical-align-center">
                <span class="es-dot" [class.es-dot--done]="event.done"></span>
                <tidy-text
                  [body]="event.label"
                  [translate]="false"
                  [class.es-muted]="!event.done" />
                @if (event.date) {
                  <tidy-text class="es-event-date" [helper]="'· ' + (event.date | date:'MMM d')" [translate]="false" />
                }
              </tidy-row>
            }
          </tidy-card>
        }

        <!-- One share link per agreement — the review/sign page before it's
             signed, the signed document itself once finished. -->
        <tidy-row><tidy-text [title]="agreementLinkTitle" /></tidy-row>
        <tidy-card>
          <tidy-row>
            <tidy-text [helper]="agreementLinkHint" />
          </tidy-row>
          <tidy-row class="extra-top-padding">
            <tidy-text [actionBody]="agreementLink" (action)="copyAgreementLink()" class="link es-link" [translate]="false" />
          </tidy-row>
        </tidy-card>

        <!-- Copying the link lives in the header (dialog icon / top nav), so the body
             only carries the action that actually moves the document forward. -->
        @if (canSend || isSigned) {
          <tidy-row class="extra-top-padding">
            <div class="es-actions">
              @if (canSend) {
                <tidy-button [text]="'Send for Signature'" [action]="sendAction" class="primary" />
              }
              @if (isSigned) {
                <tidy-button [text]="'Download PDF'" [action]="downloadAction" class="primary" />
              }
            </div>
          </tidy-row>
        }
      }

      <!-- ===== TEMPLATE ===== -->
      @if (kind === 'template' && template) {
        <tidy-card>
          <tidy-row [alignLastItemRight]="true" class="vertical-align-center">
            <tidy-text [header]="template.name" [translate]="false" />
            <span class="es-tag">{{ template.category | translate }}</span>
          </tidy-row>
          <tidy-row>
            <tidy-text [body]="template.description" [translate]="false" />
          </tidy-row>
          <tidy-row class="vertical-align-center extra-top-padding">
            <tidy-image [src]="'assets/svg/time-outline.svg'" class="body-size" />
            <tidy-text [helper]="templateUsageLabel" [translate]="false" />
          </tidy-row>
        </tidy-card>

        <tidy-row><tidy-text [title]="'Details'" /></tidy-row>
        <tidy-card>
          @for (row of detailRows; track row.label) {
            <tidy-row [alignLastItemRight]="true">
              <tidy-text [helper]="row.label" />
              <tidy-text [body]="row.value" [translate]="false" />
            </tidy-row>
          }
        </tidy-card>

        <tidy-row class="extra-top-padding">
          <div class="es-actions">
            <tidy-button [text]="'Edit Template'" [action]="editAction" class="secondary" />
            <tidy-button [text]="'Send for Signature'" [action]="useAction" class="primary" />
          </div>
        </tidy-row>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
